import { Row, Col } from 'src/componentes/grid';
import PanelCollapse from 'src/componentes/panel-collapse';
import TabelaRelacionamento from 'src/paginas/item/relacionamento';
import DocumentosAssociadosPanel from '../Components/DocumentosAssociadosPanel';

function RelacionamentosTab({
  intl,
  model,
  endpoint,
  disabled,
  disableSearch,
  isCurrentDocument,
  isDisabled,
  onChangeValue,
  onOpenDocumentoAssociadoDetail,
}) {
  return (
    <div style={{ paddingBottom: 24 }}>
      {!model?.agrupador && isCurrentDocument && (
        <div className="pb-2">
          <DocumentosAssociadosPanel
            documentosAssociados={model?.documentosAssociados || []}
            onChangeDocumentosAssociados={(itens) =>
              onChangeValue('documentosAssociados', itens)
            }
            onOpenDocumentoAssociadoDetail={onOpenDocumentoAssociadoDetail}
            documentoAtualId={model?.id}
            endpointEdit={`${endpoint}/Edit`}
            isDisabled={isDisabled}
            panelStyle={{ marginBottom: 0 }}
            contentStyle={{
              paddingBottom: 16,
              maxHeight: 420,
              overflowY: 'auto',
              overflowX: 'hidden',
            }}
          />
        </div>
      )}
      {model?.utilizarRelacionamentos && isCurrentDocument && (
        <PanelCollapse
          open={true}
          header={intl.formatMessage({ id: 'label.relacionamentos' })}
        >
          <Row>
            <Col md={12} style={{ marginTop: 20 }}>
              <TabelaRelacionamento
                disabled={disabled}
                disableSearch={disableSearch}
                model={{
                  value: model?.itensAssociados,
                  requestChange: (value) =>
                    onChangeValue('itensAssociados', value),
                }}
                allowNew={!disabled}
                info={{
                  text: intl.formatMessage({
                    id: 'label.informativoImpactoIndireto',
                  }),
                  id: 'itensAssociados',
                }}
                parameters={{ tiposIdsSelecionados: [1, 2, 3, 4, 6] }}
              ></TabelaRelacionamento>
            </Col>
          </Row>
        </PanelCollapse>
      )}
    </div>
  );
}

export default RelacionamentosTab;
